import { THRESHOLDS } from './dashboard.constants';

function getThreshold(score) {
  return THRESHOLDS.find(
    ({ min, max }) =>
      score >= min
      && (max === 100 ? score <= max : score < max),
  );
}

function getClosestMonth(validMonthIds) {
  if (!validMonthIds.length) {
    return undefined;
  }

  return validMonthIds[validMonthIds.length - 1];
}

export {
  getThreshold,
  getClosestMonth,
};
